module.exports = __webpack_public_path__ + "static/media/uploadDocBtnEng.329297da.png";